import React from 'react'
import LinkWithoutPrefetch, { LinkType } from '../../link-without-prefetch'
import { BaseButtonType } from '../types/button-interface'

type ButtonLinkWrapperProps = LinkType & Pick<BaseButtonType, 'isLoading'>

const ButtonLinkWrapper = ({
  href,
  isLoading = false,
  className,
  children,
  ...baseLinkProps
}: ButtonLinkWrapperProps) => {
  if (baseLinkProps['aria-disabled'] || isLoading) {
    return (
      <button className={className} disabled={!!baseLinkProps['aria-disabled']}>
        {children}
      </button>
    )
  }
  return (
    <LinkWithoutPrefetch className={className} href={href as string} {...baseLinkProps}>
      {children}
    </LinkWithoutPrefetch>
  )
}
export default ButtonLinkWrapper
